import Vue from 'vue'

// Scroll element to viewport when class is on
// v-in-view-when:active
// after the : is the truthy argument that triggers the functionality

Vue.directive('scrollInViewWhen', {

  update(el, binding, vnode, oldVnode) {
    if( !binding.value) return;

    const $el = $(el);
    const halfHeight = $(window).height() / 2; // middle of screen-ish

    const newScrollTop = $el.offset().top - halfHeight;
    // console.log('scrolling to '+newScrollTop)

    $('html, body').animate({
      scrollTop: `${newScrollTop}px`,
    })
  }
})



// WEBPACK FOOTER //
// ./src/directives/index.js